import $ from 'jquery';


const gridOverlay = function (options) {
    let o, m, internal, templates, elements, fn;


    o = $.extend({
        triggerKey: 59, // semicolon
        columnCount: 17
    }, options);


    m = gridOverlay.markup;


    internal = {
        triggerKey: o.triggerKey,
        columnCount: o.columnCount,
        shown: false
    };


    templates = {
        grid: `<div class='${m.CONTAINER}'></div>`,
        column: '<div class="col--1" style="border-right: 1px solid red"></div>'
    };


    elements = {
        body: $('body')
    };


    fn = {
        init () {
            $(window).on('keypress', function (e) {
                if (e.which === internal.triggerKey) {
                    fn.toggleOverlay();
                    e.preventDefault();
                }
            });
        },

        showOverlay () {
            $(templates.grid)
                .css({
                    'display': 'flex',
                    'height': '100vh',
                    'left': 0,
                    'pointer-events': 'none',
                    'position': 'fixed',
                    'top': 0,
                    'width': '100vw',
                    'z-index': 999
                })
                .appendTo(elements.body);

            $(templates.column.repeat(internal.columnCount))
                .appendTo(`.${m.CONTAINER}`);

            internal.shown = true;
        },

        removeOverlay () {
            $(`.${m.CONTAINER}`).remove();

            internal.shown = false;
        },

        toggleOverlay () {
            if (internal.shown) {
                fn.removeOverlay();
            } else {
                fn.showOverlay();
            }
        }
    };


    fn.init();
};


gridOverlay.markup = {
    // dom selector
    CONTAINER: 'grid-overlay'
};


export default gridOverlay;



// WEBPACK FOOTER //
// ./assets/js/components/grid-overlay.js